import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appCommondirective]',
  standalone:true
})
export class CommondirectiveDirective {
  @Input() beforeDecimal: any = ''
  @Input() afterDecimal: any = ''
  @Input() numberType: any = ''

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    // Prevent decimal point if afterDecimal is 0
    if (event.key === '.' && this.afterDecimal === '0') {
      event.preventDefault();
    }
  }
  a1: string = '^[+-]?\\d{0,';
  a: string = '^\\d{0,';
  b: string = '}(?:\\.\\d{0,';
  c: string = '})?$';
  private regex: RegExp = new RegExp(/^\d{0,4}(?:\.\d{0,5})?$/);
  
  private specialKeys: Array<string> = ['Backspace', 'Tab','End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  constructor(private el: ElementRef) {
  }
  @HostListener('keydown', ['$event'])
  // tslint:disable-next-line:typedef
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let regex:RegExp;
    if(this.numberType == 'negative'){
      regex = new RegExp(this.a1+this.beforeDecimal+this.b+this.afterDecimal+this.c);
    }
    else{
      regex = new RegExp(this.a+this.beforeDecimal+this.b+this.afterDecimal+this.c);
    }
    
    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key === 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    if (next && !String(next).match(regex)) {
      event.preventDefault();
  
    }
  }

}

@Directive({
  selector: '[appWholeNumberdirective]',
  standalone:true
})
export class WholeNumberdirectiveDirective {
  
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
     const allowedKeys = [
      'Backspace',
      'ArrowLeft',
      'ArrowRight',
      'Delete',
      'Tab',
      ',',
      'Control',
      'Meta',
      'a',
      'c',
      'v',
      'x',
    ];
    const ctrlCmd = event.ctrlKey || event.metaKey;
    if (ctrlCmd && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase())) {
      return;
    }
    const isNumber = /^[0-9]$/.test(event.key);
    const isAllowed = allowedKeys.includes(event.key);
    if (!isNumber && !isAllowed) {
      event.preventDefault();
    }
  }

}

